import * as React from "react";
import { KModal } from "../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../ui-kit/k-modal/k-modal-footer";
import KuikaModalIconWrapper from "../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaH5 from "../ui-kit/typography/H5/H5";
import KuikaText from "../ui-kit/typography/Text/Text";
import "./close-confirmation-modal.scss";

interface ICloseConfirmationModalProps {
  itemName?: string;
  closeType: string;
  triggerModal: boolean;
  isLoading?: boolean;
  closeWithoutSaveHandler: () => void;
  updateAndCloseHandler: () => void;
  cancel: () => void;
}

class CloseConfirmationModal extends React.Component<ICloseConfirmationModalProps, {}> {
  render() {
    const { itemName, closeType, triggerModal, isLoading, closeWithoutSaveHandler, updateAndCloseHandler, cancel } =
      this.props;

    const footer = (
      <KModalFooter
        onDelete={closeWithoutSaveHandler}
        deleteLabel="Discard"
        deleteTestId="discardButton"
        deleteOnboardingId="common_close-confirmation_close"
        submitLabel="Save & close"
        submitTestId="saveAndCloseButton"
        submitOnboardingId="common_close-confirmation_save-and-close"
        onSubmit={updateAndCloseHandler}
        loading={isLoading}
      />
    );

    return (
      <KModal
        showModal={triggerModal}
        closeModal={cancel}
        header="Unsaved Changes"
        footer={footer}
        width={400}
        centered
        isLoading={isLoading}
      >
        <div className="kuika-close-confirmation-modal">
          <div className="kuika-close-confirmation-modal__header">
            <KuikaModalIconWrapper iconName="exclamation-circle" intent="warning" />
            <div className="kuika-close-confirmation-modal__title">
              <KuikaH5>Unsaved Changes</KuikaH5>
            </div>
          </div>
          <div className="kuika-close-confirmation-modal__content">
            <div className="kuika-close-confirmation-modal__description">
              <KuikaText>
                You have unsaved changes in <strong>"{itemName}"</strong>. Closing without saving will discard them.
              </KuikaText>
            </div>
          </div>
        </div>
      </KModal>
    );
  }
}

export default CloseConfirmationModal;
